import * as React from 'react';
import styled, { keyframes } from 'styled-components';

/* https://www.w3schools.com/howto/howto_css_loader.asp */

const loadingSpin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingView = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  & > .icon {
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: ${loadingSpin} 2s linear infinite;
    margin-left: 40px;
  }
`;

export default ({ isLoading }: { isLoading: boolean }) => {
  if (!isLoading) { return null; }
  return (
    <LoadingView>
      <div className="icon" />
    </LoadingView>
  );
}
